import { render, staticRenderFns } from "./NewUploader.vue?vue&type=template&id=f013161e"
import script from "./NewUploader.vue?vue&type=script&lang=ts"
export * from "./NewUploader.vue?vue&type=script&lang=ts"
import style0 from "./NewUploader.vue?vue&type=style&index=0&id=f013161e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports